import './textInput.css';

export interface ITextInput {
  /**
   * The id of the input field
   */
  id: string,
   /**
   * The name of the input field
   */
  name: string,
  /**
   * Mobile keyboard layout for the input field
   */
  inputMode?: "search" | "text" | "email" | "tel" | "url" | "none" | "numeric" | "decimal" | undefined,
  /**
   * The initial value of the input field
   */
  value?: string,
  /**
   * The CSS class of the input field
   */
  fieldClass?: string,
  /**
   * Placeholder string for empty input
   */
  placeholder?: string,
  /**
   * Field title
   */
  title?: string,
  pattern?: string,
  autocomplete?: string,
  /**
   * Function called on value change
   */
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void,
}

/**
 * Primary UI component for user input
 */
export const TextInput: React.FC<ITextInput> = ({ id, name, fieldClass, onChange, ...args }) => {
  return (
      <input
        id={id}
        name={name}
        type="text"
        className={fieldClass}
        onChange={onChange}
        { ...args }
      />
  );
};

TextInput.defaultProps = {
  id: "",
  name: "textInput",
  placeholder: "",
  onChange: () => { console.log("in default keyUpHandler"); },
};

export default TextInput;
